import React, { useEffect, useState } from "react";
import loginBg from "../../asset/login bg.png";
import logo from "../../asset/logo.svg";
import { FaLock } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { NavLink, useNavigate } from "react-router-dom";
import { useLoginMutation } from "../../redux/userApi";
import { selectSuccess, selectUser, setProfile } from "../../redux/authSlice";
import { useDispatch, useSelector } from "react-redux";
import ButtonLoading from "../../Component/Button loading/ButtonLoading";
import { toast } from "react-toastify";
import { showConfirmDialog } from "../../Component/showConfirmDialog/ShowConfirmDialog";
import { showErrorToast } from "../../utils/Utils";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const Login = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [userData, setUserData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [login, { isLoading }] = useLoginMutation();
  const isSuccess = useSelector(selectSuccess);

  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (!userData.email.trim()) {
      newErrors.email = "Email is required.";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(userData.email)) {
      newErrors.email = "Please enter a valid email address.";
      isValid = false;
    }

    if (!userData.password.trim()) {
      newErrors.password = "Password is required.";
      isValid = false;
    } else if (userData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters long.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    if (!executeRecaptcha) {
      toast.error(
        "Unable to start security verification. Please refresh the page and try again.",
      );
    }

    try {
      const recaptchaToken = await executeRecaptcha("login");
      const response = await login({
        ...userData,
        recaptchaToken,
      }).unwrap();
      if (response.sendEmailSuccess) {
        handleConfrim();
      }

      if (response.success) {
        dispatch(setProfile(response.data));
        toast.success("User logged in successfully.");
      }
    } catch (err) {
      showErrorToast(err);
      console.error("Login error:", err);
    }
  };

  const handleConfrim = () => {
    showConfirmDialog({
      title: "Login Otp",
      message: "New device has been detected. Login code is send to you email",
      btn: "Login With Code",
      type: "info",
      onConfirm: () => {
        navigate(`/loginCode/${userData.email}`);
      },
    });
  };

  useEffect(() => {
    if (isSuccess && user) {
      navigate("/banners");
    }
  }, [isSuccess, user, navigate]);

  return (
    <div className=" w-full h-screen relative">
      <img src={loginBg} className="w-full h-full  object-fill" alt="" />
      <div className=" absolute h-screen bg-white p-8 2xl:w-[35%] xl:w-[38%] lg:w-[43%] md:w-[50%] sm:w-[65%] w-full top-0 right-0 sm:rounded-s-2xl flex flex-col gap-4 items-center justify-center">
        <img src={logo} className="w-28" alt="" />
        <span className="text-[1.8rem] text-[#333333] font-semibold">
          Welcome Back!
        </span>
        <form
          className="flex flex-col gap-4 items-center justify-center w-[90%]"
          onSubmit={handleSubmit}
        >
          <div className=" w-full flex flex-col gap-1">
            <div className="flex gap-3 w-full bg-transparent border p-3 rounded-full items-center text-[#33333390]">
              <MdEmail className=" size-6" />
              <input
                type="email"
                name="email"
                onChange={handleChange}
                placeholder="Email"
                className="w-full bg-transparent outline-none rounded-none"
              />
            </div>
            {errors.email && (
              <p className="text-sm text-red-500">{errors.email}</p>
            )}
          </div>
          <div className=" w-full flex flex-col gap-1">
            <div className="flex gap-3 w-full bg-transparent border p-3 rounded-full items-center text-[#33333390]">
              <FaLock className=" size-6" />
              <input
                type="password"
                name="password"
                onChange={handleChange}
                placeholder="Password"
                className="w-full bg-transparent outline-none rounded-none"
              />
            </div>
            {errors.password && (
              <p className="text-sm text-red-500">{errors.password}</p>
            )}
          </div>
          <div className="flex justify-end w-full">
            <NavLink
              to={"/forgotPassword"}
              className={`text-[#33333370] hover:text-[#00643b]`}
            >
              Forgot Password?
            </NavLink>
          </div>

          <button
            type="submit"
            disabled={isLoading || !executeRecaptcha}
            className="w-full p-3 bg-[#00643b] flex items-center justify-center rounded-full font-medium disabled:opacity-50 disabled:cursor-not-allowed text-white gap-2"
          >
            {isLoading ? <ButtonLoading text="Logging in..." /> : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
